import { Action } from '@ngrx/store';

export class TraderClubActions implements Action {
  public static getProfileTrader: string = '[User] get_trader_real';
  public static getProfileTraderError: string = '[User] get_trader_error_real';
  public static getProfileTraderSuccess: string =
    '[User] get_trader_success_real';

  constructor(public type: string, public payload?: any) {}
}
